import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { getZählerForMieter } from "../api";
import ZählerComponente from "../components/Zählercomponente";


function MieterDetailsPage() {
  const { mieterId, mietername } = useParams(); // cleaned name from URL
  const [zaehlerList, setZaehlerList] = useState([]);
  const [error, setError] = useState("");

  // Fetch data from API
  const fetchZaehlerData = () => {
    if (mieterId) {
      getZählerForMieter(mieterId).then(setZaehlerList).catch(console.error);
    }
  };

  useEffect(() => {
    fetchZaehlerData();
  }, []);

  return (
    <div className="max-w-4xl mx-auto mt-10 px-4">
      <h1 className="text-2xl font-bold mb-6 text-center">Zähler für {mietername}</h1>

      {error && <p className="text-red-500">{error}</p>}

      {zaehlerList.length === 0 ? (
              <p>Keine Zähler gefunden.</p>
            ) : (
              zaehlerList.map((zaehler) => (
                <ZählerComponente key={zaehler.id} mieter={false} zaehler={zaehler} refreshData={fetchZaehlerData} />
              ))
            )}
    </div>
  );
}

export default MieterDetailsPage;
